<template>
  <section>
    <b-loading :active.sync="isLoading"></b-loading>
    <b-modal
      :active.sync="isOpenModalData"
      has-modal-card
      trap-focus
      aria-role="dialog"
      aria-modal
    >
      <modalLocalizarContas :titulo="$t('LOTECONTASPAGARCADASTRO.TITULO')"
        :items.sync="localizarModalData"
        :rows.sync="itemsSelecionados"
        @link="abrirPagar"
      ></modalLocalizarContas>
    </b-modal>

    <titlebar :title-stack="titleStack"> </titlebar>
    <ValidationObserver ref="observer" v-slot="{ handleSubmit }">
      <form @submit.prevent="handleSubmit(onSubmit)">
        <div class="tile is-ancestor">
          <div
            class="tile is-parent is-vertical"
            :class="{ 'is-9': model.id, 'is-12': !model.id }"
          >
            <article class="tile is-child box">
              <div class="columns">
                <div class="column">
                  <b-field :label="$t('LOTECONTASPAGARCADASTRO.DESCRICAO')">
                    <b-input v-model="model.descricao" type="text" />
                  </b-field>
                </div>
                <div class="column">
                  <b-field :label="$t('LOTECONTASPAGARCADASTRO.OBSERVACAO')">
                    <b-input v-model="model.observacao" type="text" />
                  </b-field>
                </div>
                <div class="column">
                  <b-field :label="$t('LOTECONTASPAGARCADASTRO.TIPOBAIXA')">
                    <b-select
                      placeholder=""
                      v-model="model.tipoPagarParcelaLote"
                      expanded
                    >
                      <option
                        v-for="tipoDeBaixa in tiposDeBaixas"
                        :value="tipoDeBaixa.value"
                        :key="tipoDeBaixa.value"
                      >
                        {{ tipoDeBaixa.text }}
                      </option>
                    </b-select>
                  </b-field>
                </div>
              </div>
              <div class="columns">
                <div class="column">
                  <searchIdName table="unidade" :label="$t('LOTECONTASPAGARCADASTRO.UNIDADE')"
                    :id.sync="model.unidades"/>
                </div>
                <div class="column">
                  <searchIdName table="centroDeCusto" :label="$t('LOTECONTASPAGARCADASTRO.CENTRODECUSTO')"
                      :id.sync="model.centrosDeCusto">
                  </searchIdName>
                </div>
                <div class="column">
                  <b-field :label="$t('LOTECONTASPAGARCADASTRO.CONTACORRENTE')">
                    <b-select
                      placeholder=""
                      v-model="model.contaCorrente.id"
                      expanded
                    >
                      <option
                        v-for="option in contas"
                        :value="option.value"
                        :key="option.value"
                      >
                        {{ option.text }}
                      </option>
                    </b-select>
                  </b-field>
                </div>
              </div>
              <div class="columns">
                <div class="column is-6">
                  <div class="panel">
                      <p class="panel-tabs">
                          <a :class="{ 'is-active': status == 'emissao' }" @click="status = 'emissao'">{{$t('LOTECONTASPAGARCADASTRO.EMISSAO')}}</a>
                          <a :class="{ 'is-active': status == 'vencimento' }" @click="status = 'vencimento'">{{$t('LOTECONTASPAGARCADASTRO.VENCIMENTO')}}</a>
                      </p>
                      <div class="panel-block">
                          <periodoHora :dataInicial.sync="datas[0]"
                              :dataFinal.sync="datas[1]"/>
                      </div>
                  </div>
                </div>
              </div>
              <div class="columns">
                <div class="column">
                  <p class="buttons">
                    <b-button
                      type="is-primary"
                      v-if="model.situacaoLoteContasPagar === 1 || !model.id"
                      native-type="button"
                      class="centered"
                      @click.prevent.stop="localizarContas()"
                    >
                      {{$t('LOTECONTASPAGARCADASTRO.LOCALIZARCONTAS')}}
                    </b-button>
                  </p>
                </div>
              </div>
            </article>

            <br />
            <article class="tile is-child box" v-if="items.length">
              <div
                class="panel-heading has-text-centered button is-light fullwidth"
              >
                {{$t('LOTECONTASPAGARCADASTRO.CONTAS')}}
              </div>
              <div class="panel">
                <b-table :data="items" striped hoverable>
                  <template >
                    <b-table-column  v-slot="props" field="documento" :label="$t('LOTECONTASPAGARCADASTRO.DOCUMENTO')">
                      <a @click="abrirPagar(props.row)" class="is-primary">
                        {{ props.row.documento }}</a
                      >
                    </b-table-column>

                    <b-table-column  v-slot="props"
                      field="fornecedor"
                      :label="$t('LOTECONTASPAGARCADASTRO.FORNECEDOR')"
                    >
                      {{ props.row.fornecedor }}
                    </b-table-column>

                    <b-table-column  v-slot="props" field="notaFiscal" :label="$t('LOTECONTASPAGARCADASTRO.NOTAFISCAL')">
                      {{ props.row.notaFiscal }}
                    </b-table-column>
                    <b-table-column  v-slot="props"
                      field="contaCorrente"
                      :label="$t('LOTECONTASPAGARCADASTRO.CONTACORRENTE')"
                    >
                      {{ props.row.nome }}
                    </b-table-column>
                    <b-table-column  v-slot="props" field="dataEmissao" :label="$t('LOTECONTASPAGARCADASTRO.EMISSAO')">
                      {{ props.row.dataPagar | data }}
                    </b-table-column>
                    <b-table-column  v-slot="props" field="dataDeVencimento" :label="$t('LOTECONTASPAGARCADASTRO.VENCIMENTO')">
                      {{ props.row.dataDeVencimento | data }}
                    </b-table-column>
                    <b-table-column  v-slot="props" field="observacoes" :label="$t('LOTECONTASPAGARCADASTRO.OBSERVACAO')">
                      {{ props.row.observacao }}
                    </b-table-column>
                    <b-table-column  v-slot="props" field="valor" :label="$t('LOTECONTASPAGARCADASTRO.VALOR')">
                      {{ props.row.valor | currency }}
                    </b-table-column>
                    <b-table-column  v-slot="props" field="" label="">
                      <b-button
                        v-if="
                          model.situacaoLoteContasPagar === 1 || !model.id
                        "
                        icon-left="close"
                        type="is-danger"
                        @click.prevent.stop="removerItem(props.row)"
                      ></b-button>
                    </b-table-column>
                  </template>
                  <template slot="footer">
                    <th class="is-hidden-mobile"></th>
                    <th class="is-hidden-mobile"></th>
                    <th class="is-hidden-mobile"></th>
                    <th class="is-hidden-mobile"></th>
                    <th class="is-hidden-mobile"></th>
                    <th class="is-hidden-mobile">TOTAL:</th>
                    <th class="is-hidden-mobile">
                      {{ totalContas | currency }}
                    </th>
                    <th class="is-hidden-mobile"></th>
                    <th class="is-hidden-mobile"></th>
                  </template>
                </b-table>
              </div>
            </article>
          </div>

          <div class="tile is-parent">
            <article class="tile is-child">
              <article class="panel">
                <div class="panel-heading has-text-centered">
                  {{$t('LOTECONTASPAGARCADASTRO.SITUACAO')}}
                </div>
                <div class="panel-block has-text-centered">
                  <p
                    v-if="model.situacaoLoteContasPagar == 1"
                    class="tile is-child notification is-light is-12 fix-size"
                  >
                    {{$t('LOTECONTASPAGARCADASTRO.PENDENTE')}}
                  </p>
                  <p
                    v-if="model.situacaoLoteContasPagar == 2"
                    class="tile is-child notification is-success is-12 fix-size"
                  >
                    {{$t('LOTECONTASPAGARCADASTRO.PAGO')}}
                  </p>
                  <p
                    v-if="model.situacaoLoteContasPagar == 3"
                    class="tile is-child notification is-danger is-12 fix-size"
                  >
                    {{$t('LOTECONTASPAGARCADASTRO.CANCELADO')}}
                  </p>
                </div>
                <br />
                <div v-if="model.id && model.situacaoLoteContasPagar == 1">
                  <div class="panel-block" v-if="isInRole('pagar-alterar')">
                    <b-button
                      type="is-success"
                      native-type="button"
                      expanded
                      icon-left="download"
                      @click.prevent.stop="baixa"
                    >
                      {{$t('LOTECONTASPAGARCADASTRO.BAIXAR')}}
                    </b-button>
                  </div>
                  <div class="panel-block" v-if="baixar">
                    <b-field label="Espécie" class="fullwidth" expanded>
                      <b-select
                        placeholder=""
                        v-model="baixar.especie.id"
                        expanded
                        class="fullwidth"
                      >
                        <option
                          v-for="option in especies"
                          :value="option.id"
                          :key="option.id"
                        >
                          {{ option.nome }}
                        </option>
                      </b-select>
                    </b-field>
                  </div>

                  <div
                    class="panel-block"
                    v-if="baixar && baixar.especie.id == 3"
                  >
                    <b-field :label="$t('LOTECONTASPAGARCADASTRO.BANDEIRA')" class="fullwidth">
                      <b-select
                        placeholder=""
                        v-model="baixar.bandeira.id"
                        class="fullwidth"
                        expanded
                      >
                        <option
                          v-for="option in bandeiras"
                          :value="option.value"
                          :key="option.value"
                        >
                          {{ option.text }}
                        </option>
                      </b-select>
                    </b-field>
                  </div>

                  <div class="panel-block" v-if="baixar">
                    <b-button
                      type="is-primary"
                      native-type="button"
                      expanded
                      @click.prevent.stop="confirmarBaixar"
                    >
                      {{$t('SISTEMA.CONFIRMAR')}}
                    </b-button>
                  </div>
                  <br v-if="baixar" />
                </div>
              </article>
            </article>
          </div>
        </div>
        <nav class="level">
          <div class="level-item">
            <p class="buttons">
              <b-button
                type="is-success"
                v-if="
                  (model.situacaoLoteContasPagar === 1 || !model.id) &&
                  isInRole('pagar-parcela-lote-alterar')
                "
                :loading="salvandoDados"
                native-type="submit"
                icon-left="check-circle"
              >
                {{$t('LOTECONTASPAGARCADASTRO.SALVAR')}}
              </b-button>
              <b-button
                type="is-danger"
                native-type="button"
                icon-left="close-circle"
                @click="$router.back()"
              >
                {{$t('LOTECONTASPAGARCADASTRO.CANCELAR')}}
              </b-button>
            </p>
          </div>
        </nav>
      </form>
    </ValidationObserver>
  </section>
</template>

<style scoped>
.fix-size {
  max-height: 1.5rem;
  padding-top: 0rem;
}
.btn-action {
  margin: 0.2rem;
}

.label-parcela-cancelada {
  padding-top: 0.25rem;
}

.collapse-content {
  width: 100% !important;
}

.panel .control {
  max-width: 210px;
}

.centered {
  margin: 0 auto;
}

.fullwidth {
  width: 100%;
  max-width: 100% !important;
}
</style>

<script>
import { mapGetters, mapState } from "vuex";
import titlebar from "@/components/titlebar.vue";
import modalLocalizarContas from "@/components/financeiro/modalLocalizarContas.vue";
import moment from "moment";
import searchIdName from "@/components/searchIdName";
import periodoHora from "@/components/periodoHora.vue";

export default {
  data() {
    return {
      model: {
        id: null,
        descricao: null,
        observacoes: null,
        especie: {
          id: 0,
        },
        contaCorrente: {
          id: 0,
        },
        unidades: null,
        centrosDeCusto: null,
      },
      datas: [
          this.$moment().subtract(1, 'days').toDate(),
          this.$moment().toDate()
      ],
      status: 'emissao',
      contas: [],
      salvandoDados: false,
      isOpenModalData: false,
      localizarModalData: null,
      erroCadastro: [],
      tiposDeBaixas: [],
      especies: [],
      isLoading: false,
      itemsSelecionados: [],
      items: [],
      totalContas: 0,
      baixar: null,
      idsExcluidos: [],
    };
  },
  components: {
    titlebar,
    modalLocalizarContas,
    searchIdName,
    periodoHora
  },
  filters: {
    data: (valor) => {
      if (!valor) return null;

      return moment(valor).format("DD/MM/YYYY");
    },
  },
  created() {
    this.isLoading = true;
    let id = "";
    if (this.$route.params.id) {
      id = "?id=" + this.$route.params.id;
    }
    this.$http
      .get("/api/financeiro/PagarParcelaLote" + id)
      .then((res) => {
        const model = res.data?.item;
        this.contas = res.data?.contasCorrentes;
        this.tiposDeBaixas = res.data?.tiposDeBaixas;
        this.especies = res.data?.especies;
        this.bandeiras = res.data?.bandeira;

        if (!model.especie) {
          model.especie = {
            id: 0,
          };
        }
        model.contaCorrente = !model.contaCorrente ? {
          id: this.contas[0]?.value,
        } : model.contaCorrente;
        
        if (model.itens) {
          this.items = model.itens.map((i) => {
            return {
              ...i,
              dataPagar: i.pagar?.data,
              notaFiscal: i.pagar.notaFiscal,
              nome: i.pagar?.contaCorrente?.nome,
              fornecedor: i.pagar?.fornecedor?.nome,
              documento: i.pagar?.id,
              observacao: i.pagar?.observacoes,
            };
          });
          this.recalcularTotal();
        }
        this.model = model;
        this.isLoading = false;
      })
      .catch((ex) => {
        this.isLoading = false;
      });
  },
  computed: {
    titleStack() {
      return [
        this.$t('SIDEBAR.FINANCEIRO'),
        this.$t('LOTECONTASPAGARLISTAR.TITULO'),
        this.$route.params.id ?? this.$t('SISTEMA.NOVO')
      ];
    },
    ...mapState(["unidadeId", "config", "integradores"]),
    ...mapGetters(["isInRole"]),
  },
  watch: {
    itemsSelecionados: function (novoValor) {
      if (novoValor) {
        this.items.push(...novoValor);
        this.recalcularTotal();
      }
    },
    unidades: function(){
      this.localizarContas()
    },
    centrosDeCusto: function(){
      this.localizarContas()
    }
  },
  methods: {
    onSubmit() {
      this.$forceUpdate();
      this.isLoading = true;
      const newItem = this.getItem();
      const idsExcluidos = this.idsExcluidos.length
        ? "?idsExcluidos=" + this.idsExcluidos.map(i => i.id).join(",")
        : "";
      this.$http
        .post(`/api/financeiro/PagarParcelaLote`+idsExcluidos, newItem)
        .then(() => {
          this.isLoading = false;
          this.$router.push({ name: "financeiro" });
        })
        .catch((err) => {
          this.isLoading = false;
          console.error(err);
          if (err.body?.errors) {
            Object.keys(err.body.errors).forEach((x) => {
              this.$store.commit("ADD_ERRO", x + ": " + err.body.errors[x]);
            });
          } else {
            const mensagem =
              err.status === 500
                ? "Foi encontrado um erro no servidor ao salvar o registro"
                : "Erro ao salvar registro";
            this.$buefy.toast.open({
              duration: 5000,
              message: mensagem,
              type: "is-danger",
              queue: false,
            });
          }
        });
    },
    getItem() {
      const novoItem = {};
      novoItem.id = this.model.id;
      novoItem.descricao = this.model.descricao;
      novoItem.contaCorrente = this.contas?.find(
        (c) => c.value == this.model.contaCorrente?.id
      );
      novoItem.dataInicial = this.datas[0];
      novoItem.dataFinal = this.datas[1];
      novoItem.unidades = this.model.unidades;
      novoItem.centrosDeCusto = this.model.centrosDeCusto;
      novoItem.dataCancelamento = this.model.dataCancelamento;
      novoItem.observacao = this.model.observacao;
      novoItem.itens = this.items?.map((i) => {
        const valor = {
          ...i,
        };

        return valor;
      });

      if (this.model.especie) {
        novoItem.especie = this.model.especie;
      }

      return novoItem;
    },
    localizarContas() {
      const index = this.items.length ? this.items.length : 1;
      this.localizarModalData = null;
      let unidades = this.model.unidades;
      let centrosDeCusto = this.model.centrosDeCusto;
      let filtrarPor = this.status;
      let dataInicial = this.$moment(this.datas[0]).format('YYYY-MM-DDTHH:mm:ss');
      let dataFinal = this.$moment(this.datas[1]).format('YYYY-MM-DDTHH:mm:ss');
      
      if (dataInicial) {
        dataInicial = `dataInicial=${dataInicial}`;
      } else {
        dataInicial = "";
      }
      if (dataFinal) {
        dataFinal = `&dataFinal=${dataFinal}`;
      } else {
        dataFinal = "";
      }

      if(unidades != null){
        unidades = `unidade=${unidades}`;
      }

      if(centrosDeCusto != null){
        centrosDeCusto = `centroDeCusto=${centrosDeCusto}`;
      }

      if(filtrarPor){
        filtrarPor = `filtrarPor=${filtrarPor}`
      }

      this.isLoading = true;
      this.$http
        .get(
          `/api/financeiro/ListarParcelasLotePagar?${filtrarPor}&${centrosDeCusto}&${unidades}&${dataInicial}${dataFinal}&index=${index}&_=${new Date().getTime()}`
        )
        .then((res) => {
          //filtrando os dados quejá existem
          const idsSelecionados = this.items?.map((i) => i.id);
          this.localizarModalData = res.data?.filter(
            (i) => idsSelecionados.indexOf(i.id) < 0
          );

            
          this.isOpenModalData = true;
          this.isLoading = false;
        })
        .catch((e) => {
          console.error(e);
          this.isLoading = false;
        });
    },
    abrirPagar(item) {
      this.$router.push({
        name: "contaspagar",
        params: { id: item.documento },
      });
    },
    removerItem(item) {
      if (this.model.id) {
        this.idsExcluidos.push(this.items?.find((i) => i.id == item.id));
      }
      this.items = this.items?.filter((i) => i.id !== item.id);
      this.recalcularTotal();
    },
    recalcularTotal() {
      this.totalContas = 0;
      this.items.forEach((v) => {
        this.totalContas += parseFloat(v.valor?.toString());
      });
      this.totalContas = this.totalContas.toFixed(2);
    },
    baixa() {
      this.baixar = {
        especie: {
          id: this.especies[0]?.id,
          nome: this.especies[0]?.nome,
        },
        bandeira: {
          id: this.bandeiras[1]?.id,
          nome: this.bandeiras[1]?.nome
        }
      };
      this.$forceUpdate();
    },
    confirmarBaixar() {
      this.isLoading = true;
      try {
        const especie = this.baixar.especie;
        this.$http
            .post(`/api/financeiro/PagarParcelaLoteBaixar?id=${this.model.id}`, especie)
            .then((res) => {
            this.isLoading = false;
            this.$router.push({ name: "financeiro" });
            })
            .catch((e) => {
            this.isLoading = false;
            console.error(e);
            this.$buefy.toast.open({
                duration: 5000,
                message: "Erro ao baixar",
                type: "is-danger",
                queue: false,
            });
            });
      }catch(e){
          this.isLoading = false;
      }
    },
  },
};
</script>
